import { render } from "./FiltersPanel.vue?vue&type=template&id=2245307a&scoped=true"
import script from "./FiltersPanel.vue?vue&type=script&lang=js"
export * from "./FiltersPanel.vue?vue&type=script&lang=js"

import "./FiltersPanel.vue?vue&type=style&index=0&id=2245307a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2245307a"

export default script